export default "__VITE_ASSET__CEjjq6o6__"